// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root___eOsW","row":"ProcedureTreatmentSummary_row__3_HyF"};